import e from "react";
import { Divider as d } from "../../../Divider/Divider.js";
import { Link as r } from "../../../Link/Link.js";
import { VisuallyHidden as n } from "../../../VisuallyHidden/VisuallyHidden.js";
import { Text as k } from "../../../Text/Text.js";
import { Facebook as p, YouTube as f, Tiktok as _, Instagram as u, Twitter as E, LinkedIn as x } from "@olxbr/ds-icons";
import { fixedLinks as w } from "../../utils/links.js";
import { cls as i } from "../../../../helpers/cls.js";
import { sendClickEvent as l } from "../../utils/sendClickEvent.js";
var b = Object.defineProperty,
  c = Object.getOwnPropertySymbols,
  v = Object.prototype.hasOwnProperty,
  h = Object.prototype.propertyIsEnumerable,
  s = (a, t, o) => t in a ? b(a, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : a[t] = o,
  y = (a, t) => {
    for (var o in t || (t = {})) v.call(t, o) && s(a, o, t[o]);
    if (c) for (var o of c(t)) h.call(t, o) && s(a, o, t[o]);
    return a;
  };
const m = _ref => {
  let {
    componentName: a
  } = _ref;
  return e.createElement(e.Fragment, null, e.createElement(d, null), e.createElement("div", {
    className: "olx-static-footer__links-container"
  }, e.createElement("nav", {
    className: "olx-static-footer__legal-container",
    "aria-label": "Links comuns"
  }, e.createElement("div", {
    className: "olx-static-footer__legal-container-links"
  }, w.map(t => e.createElement(r, y({
    key: t.name,
    dsParentName: a,
    href: t.href,
    variant: "grey",
    size: "small",
    onClick: () => l(t.clickEvent, a),
    "data-ds-component": "DS-Footer-Link"
  }, (t == null ? void 0 : t.rel) && {
    rel: t.rel
  }), t.name))), e.createElement("address", {
    className: "olx-static-footer__legal-container-address"
  }, e.createElement(k.BodySmall, null, "\xA9 Bom Neg\xF3cio Atividades de Internet Ltda. - Rua do Catete, 359, Flamengo - 22220-001 - Rio de Janeiro, RJ"))), e.createElement("nav", {
    className: "olx-static-footer__social-container"
  }, e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__facebook-link"),
    href: "https://www.facebook.com/olxbrasil",
    variant: "grey",
    onClick: () => l("facebook", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(p, null)), e.createElement(n, null, "Facebook")), e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__youtube-link "),
    href: "https://www.youtube.com/user/OLXBrasil",
    variant: "grey",
    onClick: () => l("youtube", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(f, null)), e.createElement(n, null, "Youtube")), e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__tiktok-link"),
    href: "https://www.tiktok.com/@olx_brasil",
    variant: "grey",
    onClick: () => l("tiktok", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(_, null)), e.createElement(n, null, "TikTok")), e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__instagram-link"),
    href: "https://instagram.com/olxbr",
    variant: "grey",
    onClick: () => l("instagram", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(u, null)), e.createElement(n, null, "Instagram")), e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__twitter-link"),
    href: "https://twitter.com/olx_Brasil",
    variant: "grey",
    onClick: () => l("twitter", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(E, null)), e.createElement(n, null, "Twitter")), e.createElement(r, {
    className: i("olx-static-footer__social-link", "olx-static-footer__linkedin-link"),
    href: "https://www.linkedin.com/company/olx-brasil",
    variant: "grey",
    onClick: () => l("linkedin", a),
    "data-ds-component": "DS-Footer-Link"
  }, e.createElement("span", {
    className: "olx-static-footer__icon-wrapper",
    "aria-hidden": !0
  }, e.createElement(x, null)), e.createElement(n, null, "LinkedIn")))));
};
export { m as StaticFooter, m as default };